import {useRef, useEffect} from 'react';

// custom useEffect which only when a dependency updates and not on mount
export const useUpdateEffect = (effect: () => void, dependencies: any[]) => {
  const isInitialMount = useRef(true);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      effect();
    }
  }, [...dependencies]);
};
